(() => {
  const init = (root) => {
    if (root.dataset.shippingReady) return;
    root.dataset.shippingReady = 'true';
    const form = root.querySelector('[data-tracking-form]');
    const input = form.querySelector('input');
    const error = form.querySelector('[role="alert"]');
    form.noValidate = true;
    form.addEventListener('submit', (event) => {
      if (!input.value.trim()) {
        event.preventDefault();
        error.hidden = false;
        input.setAttribute('aria-invalid', 'true');
        input.focus();
        return;
      }
      error.hidden = true;
      input.removeAttribute('aria-invalid');
    });
    input.addEventListener('input', () => {
      if (input.value.trim()) {
        error.hidden = true;
        input.removeAttribute('aria-invalid');
      }
    });
    root.querySelectorAll('[data-faq-toggle]').forEach((button) => {
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      const setOpen = (open) => {
        button.setAttribute('aria-expanded', String(open));
        panel.classList.toggle('is-closed', !open);
        panel.inert = !open;
        panel.setAttribute('aria-hidden', String(!open));
      };
      setOpen(false);
      button.addEventListener('click', () => setOpen(button.getAttribute('aria-expanded') !== 'true'));
    });
  };
  document.querySelectorAll('[data-switz-shipping]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-switz-shipping]').forEach(init);
  });
})();
